// extracted by mini-css-extract-plugin
module.exports = {"element":"LayoutMain_element__30u3W"};